define('home/views/ProfileUserModuleView',[
    'backbone-marionette',
    'moment',

    'home/mixins/withTruncate',
    'home/templates/profileUserModule',
    'home/models/Session',
], function (
    Marionette,
    moment,

    withTruncate,
    profileUserModuleTemplate,
    Session
) {
    'use strict';

    var ProfileUserModuleView = Marionette.ItemView.extend({
        template: profileUserModuleTemplate,

        events: {
            'click [data-action=toggle-blacklist]': 'toggleBlacklist',
        },

        templateHelpers: function () {
            return {
                joinDate: moment(this.model.get('joinedAt')).format('ll'),
                numLines: 9,
                isGlobalAdmin: Session.get().user.isGlobalAdmin(),
            };
        },

        toggleBlacklist: function () {
            if (this.model.get('isOnGlobalBlacklist')) {
                this.model.removeFromBlacklist();
            } else {
                this.model.confirmBlacklist({
                    notes: 'Added via user profile',
                    retroactive: true,
                });
            }
        },
    });

    withTruncate.call(ProfileUserModuleView.prototype);

    return ProfileUserModuleView;
});

